import { normalizeRecipeDiscovery } from "./discoveryOptions";

function nowIso() {
  return new Date().toISOString();
}

function makeTemplateId() {
  return `tpl_${Math.random().toString(36).slice(2, 9)}`;
}

function cleanString(value) {
  return String(value || "").trim();
}

function uniqueList(values = []) {
  return Array.from(new Set((values || []).filter(Boolean)));
}

export function createTemplateFromDraft(draft = {}, options = {}) {
  const now = options.now || nowIso();
  const name = cleanString(options.name) || cleanString(draft.prompt).slice(0, 48) || "Untitled template";
  const recipe = normalizeRecipeDiscovery(draft.recipe || { brandId: null, voiceId: null, styleSkillId: "" });

  return {
    id: options.id || draft.id || makeTemplateId(),
    name,
    prompt: draft.prompt || "",
    platforms: uniqueList(draft.platforms),
    recipe,
    audience: draft.audience || "",
    goal: draft.goal || "authority",
    model: draft.model || "anthropic",
    researchMode: draft.researchMode || draft.research_mode || "deep",
    imageMode: draft.imageMode || draft.image_mode || "generate",
    imageTextMode: draft.imageTextMode || draft.image_text_mode || "auto",
    uploadedName: draft.uploadedName || "",
    url: draft.url || "",
    notes: draft.notes || "",
    createdAt: draft.createdAt || now,
    updatedAt: now,
  };
}

export function upsertCreateTemplate(templates = [], template) {
  if (!template?.id) return templates;
  return [template, ...templates.filter((item) => item.id !== template.id)];
}

export function deleteCreateTemplate(templates = [], templateId) {
  return templates.filter((item) => item.id !== templateId);
}

export function applyCreateTemplate(template = {}) {
  const recipe = normalizeRecipeDiscovery(template.recipe || { brandId: null, voiceId: null, styleSkillId: "" });
  return {
    prompt: template.prompt || "",
    platforms: uniqueList(template.platforms),
    recipe,
    audience: template.audience || "",
    goal: template.goal || "authority",
    model: template.model || "anthropic",
    researchMode: template.researchMode || "deep",
    url: template.url || "",
    notes: template.notes || "",
    imageMode: template.imageMode || "generate",
    imageTextMode: template.imageTextMode || template.image_text_mode || "auto",
    uploadedImage: null,
    uploadedName: "",
  };
}
